export const HandleSaveNobatPrefrence = (
  data,
  setNobatPrefrences
) => {
  const filtered_prefrences = data.filter((fl) =>
    [
      'webAppnoeEntekhabeNobatPatient',
      'webAppgetFastNobat',
      'webAppshowTodayNobat',
      'webAppshowTimeNobat',
      'webAppshowHolidays',
      'webAppcanRegister',
      'webAppnobatAgreementRule',
    ].includes(fl.Key)
  );
  setNobatPrefrences(filtered_prefrences);
  localStorage.setItem(
    'nobat_prefrence',
    JSON.stringify(filtered_prefrences)
  );
};
